import { logAuditEvent } from './auditLogs.service'

const postJson = async (url, body) => {
  const resp = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body || {})
  })
  const data = await resp.json().catch(() => null)
  if (!resp.ok) {
    const err = new Error(data?.error || `http_${resp.status}`)
    err.status = resp.status
    err.data = data
    throw err
  }
  return data
}

export const notifyOrderCreated = async (orderId, options = {}) => {
  if (!orderId) return null
  const payload = { orderId }
  if (options && typeof options === 'object' && options.force) {
    payload.force = true
  }
  try {
    const result = await postJson('/api/notifications/order-created', payload)
    logAuditEvent({
      level: 'info',
      category: 'notifications',
      action: 'order_created_sent',
      message: `Notificación enviada para pedido ${orderId}`,
      metadata: { orderId }
    })
    return result
  } catch (error) {
    logAuditEvent({
      level: 'error',
      category: 'notifications',
      action: 'order_created_error',
      message: `Error enviando notificación de pedido ${orderId}`,
      error,
      metadata: { orderId }
    })
    throw error
  }
}

export const notifyPaymentApproved = async (orderId) => {
  if (!orderId) return null
  try {
    const result = await postJson('/api/notifications/payment-approved', { orderId })
    logAuditEvent({
      level: 'info',
      category: 'notifications',
      action: 'payment_approved_sent',
      message: `Notificación de pago aprobada para pedido ${orderId}`,
      metadata: { orderId }
    })
    return result
  } catch (error) {
    logAuditEvent({
      level: 'error',
      category: 'notifications',
      action: 'payment_approved_error',
      message: `Error enviando notificación de pago aprobado ${orderId}`,
      error,
      metadata: { orderId }
    })
    throw error
  }
}

export const notifyOrderDelivered = async (orderId) => {
  if (!orderId) return null
  try {
    const result = await postJson('/api/notifications/order-delivered', { orderId })
    logAuditEvent({
      level: 'info',
      category: 'notifications',
      action: 'order_delivered_sent',
      message: `Notificación de entrega enviada para pedido ${orderId}`,
      metadata: { orderId }
    })
    return result
  } catch (error) {
    logAuditEvent({
      level: 'error',
      category: 'notifications',
      action: 'order_delivered_error',
      message: `Error enviando notificación de entrega ${orderId}`,
      error,
      metadata: { orderId }
    })
    throw error
  }
}

export const notifyWelcome = async (uid) => {
  if (!uid) return null
  try {
    const result = await postJson('/api/notifications/welcome', { uid })
    logAuditEvent({
      level: 'info',
      category: 'notifications',
      action: 'welcome_sent',
      message: `Notificación de bienvenida enviada para ${uid}`,
      metadata: { uid }
    })
    return result
  } catch (error) {
    logAuditEvent({
      level: 'error',
      category: 'notifications',
      action: 'welcome_error',
      message: `Error enviando bienvenida para ${uid}`,
      error,
      metadata: { uid }
    })
    throw error
  }
}

export default {
  notifyOrderCreated,
  notifyPaymentApproved,
  notifyOrderDelivered,
  notifyWelcome
}
